import { useMemo } from 'react';

import { MEDIA_AVAILABLE } from '@/api/authenticatedMedia';
import { MEDIA_LOADING, useAuthenticatedMedia } from '@/hooks/useAuthenticatedMedia';
import { productReferencePresentation } from '@/utils/productReference';


export function useProductReferenceMedia(resolvedProduct, owner) {
  const presentation = useMemo(
    () => productReferencePresentation(resolvedProduct),
    [resolvedProduct],
  );
  const requests = useMemo(
    () => (presentation.requestKey && presentation.requestUrl ? [{
      key: presentation.requestKey,
      url: presentation.requestUrl,
    }] : []),
    [presentation.requestKey, presentation.requestUrl],
  );
  const loaded = useAuthenticatedMedia(requests, ...(owner ? [owner] : []));
  const mediaResult = presentation.requestKey
    ? loaded[presentation.requestKey] || { state: MEDIA_LOADING }
    : null;
  return {
    ...presentation,
    mediaResult,
    imageUrl: mediaResult?.state === MEDIA_AVAILABLE ? mediaResult.url : null,
  };
}


export default useProductReferenceMedia;
